import { jsx as _jsx } from "react/jsx-runtime";
import { signOut } from '#pplx/frontend/apps/ask/auth/signOut.js';
import { useLinkedAccounts } from '#pplx/frontend/apps/ask/auth/useLinkedAccounts.js';
import { signOutSelectedEvent } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { AccountMenuSignOutItem } from '#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/AccountMenuSignOutItem.js';
import { MultiAccountSignOutSubmenu } from '#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/MultiAccountSignOutSubmenu.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
/**
 * The sign-out menu for multi-account web (plan PR 4.2). Replaces the plain single-session
 * sign-out item when multi-account is enabled (the popover gates the mount), so the
 * linked-accounts query fires solely for enabled users.
 */
export const AccountMenuMultiSignOut = () => {
    const { track } = useInstrumentation();
    const { accounts, signOutAccount } = useLinkedAccounts({ reason: 'sidebar-account-signout' });
    const signOutAccounts = useMemo(() => accounts.map(({ userId, email, avatarUrl }) => ({ id: userId, email, avatarUrl })), [accounts]);
    const handleSignOutAccount = useCallback(({ id }) => {
        track(signOutSelectedEvent({ name: 'sign out selected', data: { allSessions: false } }));
        void signOutAccount(id);
    }, [signOutAccount, track]);
    const handleSignOutAll = useCallback(() => {
        track(signOutSelectedEvent({ name: 'sign out selected', data: { allSessions: true } }));
        signOut({ redirect: true, callbackUrl: '/' });
    }, [track]);
    return (_jsx(MultiAccountSignOutSubmenu, { accounts: signOutAccounts, singleAccountItem: _jsx(AccountMenuSignOutItem, {}), onSignOutAccount: handleSignOutAccount, onSignOutAll: handleSignOutAll }));
};
//# sourceMappingURL=AccountMenuMultiSignOut.js.map